<script>
import Icon from '@/packages/ui/components/Icon/Icon.vue';

export default {
  components: {
    Icon,
  },
  props: {
    questionData: {
      type: Object,
      default: () => {},
    },
    answer: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    design() {
      switch (this.questionData.button_design) {
        case 3:
          return 'gray-scale';
        case 2:
          return 'yellow-bordered';
        default:
          return 'white-bordered';
      }
    },
  },
  methods: {
    handleAnswerChange(value) {
      this.$emit('change', value);
    },
  },
};
</script>

<template>
  <div class="cxm-EmojiContainer">
    <div :class="['cxm-Emoji', design, answer === 1 ? 'is-selected' : '']">
      <Icon
        name="very-sad"
        size="32"
        :handle-click="() => handleAnswerChange(1)"
      />
    </div>
    <div :class="['cxm-Emoji', design, answer === 2 ? 'is-selected' : '']">
      <Icon
        name="sad"
        size="32"
        :handle-click="() => handleAnswerChange(2)"
      />
    </div>
    <div :class="['cxm-Emoji', design, answer === 3 ? 'is-selected' : '']">
      <Icon
        name="normal"
        size="32"
        :handle-click="() => handleAnswerChange(3)"
      />
    </div>
    <div :class="['cxm-Emoji', design, answer === 4 ? 'is-selected' : '']">
      <Icon
        name="happy"
        size="32"
        :handle-click="() => handleAnswerChange(4)"
      />
    </div>
    <div :class="['cxm-Emoji', design, answer === 5 ? 'is-selected' : '']">
      <Icon
        name="very-happy"
        size="32"
        :handle-click="() => handleAnswerChange(5)"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cxm-EmojiContainer {
  display: flex;
}
.cxm-Emoji {
  margin-left: var(--track-spacing-md);
  border-radius: 100%;
  height: var(--track-spacing-lg);
  width: var(--track-spacing-lg);
  transition: 0.2s ease-in;
  &:hover,
  &.is-selected {
    cursor: pointer;
    transform: scale(1.4);
  }
  &.gray-scale {
    background-color: var(--track-color-bluegray-10);
    fill: var(--track-color-bluegray-40);
    &:hover,
    &.is-selected {
      background-color: #ffd21f;
      fill: black;
    }
    &::v-deep svg > path:first-child {
      fill: transparent;
    }
  }
  &.yellow-bordered {
    background-color: transparent;
    fill: var(--track-color-bluegray-20);
    &:hover,
    &.is-selected {
      background-color: #ffd21f;
      fill: black;
    }
  }
  &.white-bordered {
    background-color: transparent;
    fill: var(--track-color-bluegray-20);
    &:hover,
    &.is-selected {
      fill: black;
    }
  }
}
</style>
